import React from 'react';

import HeaderEnum from '../topLevelMenu/headerEnum';

import BaseMenu from './BaseMenu';

const ContactMenu: React.FC = () => {
  return (
    <BaseMenu
      className={'contact-menu'}
      headerEnum={HeaderEnum.Contact}
      menuListClassName={'contact-menu-list'}
    />
  );
};

export default ContactMenu;
